var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventHostNoExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "40px",
    viewBox: "0 0 34 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EventHostNoExperience") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.4709201%",
    y1: "0%",
    x2: "61.8674045%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4199FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D0FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom-Event-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-704.000000, -213.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(222.000000, 213.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ThumbsUp",
    transform: "translate(482.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.63361834,20.0209177 L4.89570767,20.0209177 C5.90072186,20.021065 6.84881026,19.5544499 7.46176593,18.757996 L13.9123119,10.3751991 C14.3476849,9.80945236 14.5838017,9.11563857 14.5839066,8.40176252 L14.5839066,2.21985443 C14.577512,1.78864136 14.7460239,1.37322016 15.0510169,1.06831868 C15.3560098,0.763417206 15.7714815,0.595029911 16.2026927,0.601553888 C18.2793769,0.601553888 21.058889,3.02900471 21.058889,7.88390635 C21.1642325,10.7167456 20.7118703,13.5426762 19.7275131,16.2010811 C19.6679582,16.3263892 19.6761533,16.4733723 19.7492689,16.5912833 C19.8223845,16.7091942 19.950402,16.7818764 20.0891224,16.7842357 L30.6392282,16.7842357 C32.2732566,16.7565356 33.6855598,17.9194818 33.9718754,19.5284689 C34.1780488,20.8772058 33.5113948,22.209379 32.3082625,22.8528627 C33.4352284,23.4544045 34.0988757,24.6663397 33.9986834,25.9398648 C33.8984911,27.21339 33.0534879,28.3066348 31.8463186,28.7245426 C32.4348764,29.1399954 32.8649228,29.7429848 33.0660317,30.4347626 C33.2747267,31.2172988 33.1821522,32.0496605 32.8066181,32.7672192 C32.3737668,33.7863122 31.4005852,34.4719009 30.2952584,34.5364263 C30.6429898,35.0999524 30.8067268,35.7577282 30.7637564,36.4185098 C30.5824802,38.1622373 29.0951145,39.4760817 27.3423454,39.440767 L15.2670722,39.440767 C12.71049,39.4408262 10.2110708,38.6842745 8.08367883,37.2664184 L7.3054381,36.7477531 C6.77361496,36.3933257 6.14879543,36.204216 5.50969089,36.2042468 L1.63386108,36.2042468 C1.20457698,36.2043756 0.792831172,36.0339334 0.489235937,35.7304293 C0.185640702,35.4269251 0.0150750278,35.0152304 0.0150750471,34.5859463 L0.0150750471,21.6395419 C0.0149891826,21.2102438 0.185483633,20.7985028 0.489035669,20.4949355 C0.792587704,20.1913683 1.20432021,20.0208533 1.63361834,20.0209177 Z",
    id: "EventHostNoExperience"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventHostNoExperience);
export default __webpack_public_path__ + "static/media/EventHostNoExperience.a4eb633abf5ce721bc1074857728d700.svg";
export { ForwardRef as ReactComponent };